import { useCallback, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Collapse, Grid, IconButton, Typography } from '@material-ui/core';
import { ExpandLessOutlined, ExpandMoreOutlined } from '@material-ui/icons';
import KeyInformationItem from './key-information-item';
import { formatDate } from '@roc/feature-utils';

const useStyles = makeStyles(() => ({
  outerContainer: {
    width: '100%',
    borderRadius: '8px',
    marginBottom: '4px',
    padding: '10px',
    border: '1px solid #E1E1E1',
  },
  collapseBtn: {
    color: '#00B1FE',
  },
  collapseBtnIcon: {
    fontSize: '28px',
  },
  titleContainer: {
    paddingBottom: '12px',
  },
  title: {
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '157%',
    letterSpacing: '0.1px',
    color: '#00B1FE',
  },
  details: {
    padding: '12px 0',
    '& > .MuiGrid-item:first-of-type': {
      minWidth: '357px',
      paddingRight: '20px',
    },
    '& > .MuiGrid-item:not(:first-of-type)': {
      minWidth: '362px',
      padding: '0 40px 0 20px',
      borderLeft: '1px solid #E1E1E1',
    },
    '& > .MuiGrid-item:not(:first-of-type):last-of-type': {
      padding: '0 0 0 20px',
    },
  },
}));

export default function PayoffsKeyInformationCollapse({ loan, currentPayoff }) {
  const classes = useStyles();
  const [isExpanded, setIsExpanded] = useState(true);

  const handleExpandClick = useCallback((event) => {
    event.stopPropagation();
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  const informationItems = [{
    label: 'Payoff Status',
    value: currentPayoff?.payoffStatus,
  }, {
    label: 'Payoff Good Through Date',
    value: formatDate(currentPayoff?.goodThroughDate, 'MM/dd/yyyy'),
  }, {
    label: 'Requested Date',
    value: formatDate(currentPayoff?.requestedDate, 'MM/dd/yyyy'),
  }];

  return (
    <Grid className={classes.outerContainer}>
      <Grid
        container
        direction='row'
        justifyContent='space-between'
        alignItems='baseline'
        className={isExpanded ? classes.titleContainer : ''}
      >
        <Grid item>
          <Typography variant='h5' component='h5' className={classes.title}>
            Key Information
          </Typography>
        </Grid>
        {informationItems.map((item, index) => (
          <Grid item key={index}>
            <KeyInformationItem
              label={item.label}
              value={item.value}
            />
          </Grid>
        ))}
        <Grid item>
          <IconButton onClick={handleExpandClick} className={classes.collapseBtn} >
            {isExpanded ? (
              <ExpandLessOutlined className={classes.collapseBtnIcon} />
            ) : (
              <ExpandMoreOutlined className={classes.collapseBtnIcon} />
            )}
          </IconButton>
        </Grid>
      </Grid>
      <Collapse in={isExpanded} timeout='auto' unmountOnExit>
      </Collapse>
    </Grid>
  );
}
